import { submitInternalEventAndRedirectToPage as i } from "../../../../shared/data/tracking/utilities/index.js";
import { TRACKING_EVENTS as o } from "../../../../shared/data/tracking/types/index.js";
import { useNavigationEventBus as c } from "@ado/acs-standard-library";
class l {
  searchRedirectionHost;
  navigationEventBus;
  constructor(e = "", t) {
    this.searchRedirectionHost = e, this.navigationEventBus = t ?? c();
  }
  handle(e, t, r) {
    if (!this.validateSearchQuery(e))
      return;
    const a = t || this.getSearchPageUrl(e), n = this.createTrackingEvent(e, r);
    i(
      n,
      {
        url: a
      },
      this.navigationEventBus
    );
  }
  createTrackingEvent(e, t = "") {
    return {
      ...o.PRODUCT_MENU_SEARCH_BAR_CLICK,
      extra: `${t}:${e}`
    };
  }
  getSearchPageUrl(e) {
    return this.searchRedirectionHost + "/searchzoom/?zoom_per_page=10&zoom_and=0&zoom_query=" + encodeURI(e);
  }
  validateSearchQuery(e) {
    return e.includes("@") ? (alert("You've entered an invalid character. Please try again."), !1) : !0;
  }
}
export {
  l as AvailableContractsSearchSubmitHandler
};
//# sourceMappingURL=index5.js.map
